import React from 'react';
import { ConfirmationTypes, deleteWorkshift } from '@pharmaplan/common';
import { useAppDispatch } from '../useAppDispatch';
import { resetDialog, setDialog } from '../../reducers/dialogReducer';
import ConfirmationModal from '../../components/Modals/ConfirmationModal';
import strings from '../../localization';
import MultiShiftDelete from '../../components/MultiShiftDelete';

const useLongTermPharmacyActions = () => {
  const dispatch = useAppDispatch();

  const handleDelete = (workshiftId: string) =>
    () => {
      dispatch(
        deleteWorkshift({
          id: workshiftId,
          recurrenceId: '',
        }),
      );

      dispatch(resetDialog());
    };

  const confirmMultipleDelete = (longTermContractId?: string) => {
    dispatch(
      setDialog({
        heading: {
          title: strings.deleteShifts,
        },
        Component: (
          <MultiShiftDelete
            longTermShiftContractId={longTermContractId ?? ''}
          />
        ),
        maxWidth: 'lg',
        showCloseButton: true,
      }),
    );
  };

  const confirmSingleDelete = (workshiftId: string) => {
    dispatch(
      setDialog({
        heading: {
          title: '',
        },
        Component: (
          <ConfirmationModal
            type={ConfirmationTypes.deleteWorkshift}
            confirmAction={handleDelete(workshiftId)}
          />
        ),
        showCloseButton: false,
      }),
    );
  };

  const deleteShift = (
    workshiftId: string,
    longTermContractId?: string,
  ) => {
    if (longTermContractId) {
      confirmMultipleDelete(longTermContractId);
      return;
    }

    confirmSingleDelete(workshiftId);
  };

  return { deleteShift };
};

export default useLongTermPharmacyActions;
